// extracted by mini-css-extract-plugin
module.exports = {"itemModalInfo":"ItemModalInfo_itemModalInfo__JP0CR","itemModalIcon":"ItemModalInfo_itemModalIcon__fZeF_","itemModalBody":"ItemModalInfo_itemModalBody__CTSov"};